import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { FiksanaTrakaDoljeInfo } from '../Layout/FiksanaTrakaDoljeInfo.jsx'


import { MaratonTimer } from './MaratonTimer.jsx'
import { MaratonProgress } from './MaratonProgress.jsx'



export  class MaratonHappyHour extends React.Component {


    constructor(props) {
        super(props);
        this.state = { maraton: null, loading: true, obavijestTrakaVidljiva: false };

        this.fetchData = this.fetchData.bind(this);
        this.setData = this.setData.bind(this);

        this.renderLine1 = this.renderLine1.bind(this);
        this.renderLine2 = this.renderLine2.bind(this);
        this.renderLine3 = this.renderLine3.bind(this);

        this.sakrijObavijest = this.sakrijObavijest.bind(this);

        this.fetchData();
    }

    fetchData() {



        var nadimak = null;
        if (this.props.userChecked && this.props.user)
            nadimak = this.props.user.nadimak;

        var promises = Promise.all([casino.repos.casinoMaratonHappyHourRepo.get(false, nadimak)]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }

    componentWillUnmount() {
        clearTimeout(this.timeouter);
        if (this.dataPromises)
            this.dataPromises.cancel();
    }

    setData(data) {
        var [maraton] = data;

        this.setState({
            maraton: maraton,
            loading: false
        });


        //kad prikazati traku, ako je utrka aktivna, ako je nije vidiio u zadnjih 1 min i ako nije kliknuo stop, i ako je prvih pol sata
        var firstHalf = new Date().getMinutes() <= 25;
        var zadnjuVidio = new Date(parseInt(localStorage.getItem("HHObavjestVidio") || 0));
        var zadnjuVidioDiff = (new Date() - zadnjuVidio);

        this.setState({
            obavijestTrakaVidljiva: firstHalf && zadnjuVidioDiff > 31 * 60 * 1000 && maraton.aktivnaUtrka
        });

        // idemo f krug
        var timeoutOut = 5000;
        if (maraton.sljedecaUtrkaStartMiliSecond > 0 && maraton.sljedecaUtrkaStartMiliSecond < 24 * 60 * 60 * 1000)
            timeoutOut = maraton.sljedecaUtrkaStartMiliSecond;
        if (maraton.sljedecaUtrkaStartMiliSecond > 0 && maraton.sljedecaUtrkaStartMiliSecond > 24 * 60 * 60 * 1000)
            timeoutOut = 24 * 60 * 60 * 1000;

        this.timeouter = setTimeout(() => {
            this.fetchData();
        }, timeoutOut);

    }

    sakrijObavijest() {

        localStorage.setItem("HHObavjestVidio", new Date().getTime());
        this.setState({ obavijestTrakaVidljiva: false });
    }


    render() {

        if (!this.state.maraton || !this.state.maraton.aktivno)
            return null;


        var firstHalf = true;
        if (new Date().getMinutes() >= 30)
            firstHalf = false;
        let aktivnaUtrka = this.state.maraton.aktivnaUtrka;
        let sljedecaUtrka = new Date(this.state.maraton.sljedecaUtrka);



        return <div className={"maraton maximum margin-center  " + this.props.extraClass} >
            {this.props.hideHeader && <hr className="margin-bottom"></hr>}
            {!this.props.hideHeader && <NavLink to='/promotions'>
                <div id="game-tabs" className="relative maximum no-buttons"><div className="maximum"><ul><li><span>HAPPY HOUR MARATON</span></li></ul>
                    <div className="goto-maraton-container">
                        <div className="goto-maraton"></div>
                    </div>
                </div></div>
            </NavLink>}
            <div id="game-tabs" className="relative maximum no-buttons lines"><div className="maximum"><ul><li>
                <div>
                    {this.renderLine1(firstHalf, aktivnaUtrka, sljedecaUtrka)}
                    <hr className="sep" style={{ display: 'none' }}></hr>
                    {this.renderLine2(firstHalf, aktivnaUtrka, sljedecaUtrka)}
                    <hr className="sep"></hr>
                    {this.renderLine3(firstHalf, aktivnaUtrka, sljedecaUtrka)}
                </div>
            </li></ul></div></div>
            <hr className="tablet-hidden"></hr>
            {this.props.hideHeader && <hr></hr>}

            <FiksanaTrakaDoljeInfo popUpCode="poceoHapyHour" sakrijObavijest={this.sakrijObavijest}
                activeHH={this.state.obavijestTrakaVidljiva}></FiksanaTrakaDoljeInfo>

        </div>
    }

    renderLine1(firstHalf, aktivnaUtrka, sljedecaUtrka) {

        var trenutniPobjednik = this.state.maraton.trenutniPobjednik;

        var now = new Date();
        var toDate = new Date(now.getFullYear(), now.getMonth(), now.getDay(), now.getHours(), 30, 0);
        var diff = new Date(toDate - now);
        var display = diff.getMinutes() + 1;

        var nextDate = new Date(now.getFullYear(), now.getMonth(), now.getDay(), now.getHours(), 0, 0);
        nextDate.setTime(nextDate.getTime() + 60 * 60 * 1000);


        if (!aktivnaUtrka)
            return <div className={"line timer not-started"}>
                <div key="first-not-started" >
                    <div className="maraton-pocinje center-verticaly">
                        <span>
                            {casino.utils.dateToShortDateString(sljedecaUtrka)}.
                        </span>
                        <span>
                            {casino.utils.dateToTimeString(sljedecaUtrka)}
                        </span>
                    </div>
                    <div className="center-verticaly content" >
                        "Happy Hour" započinje <b>{this.state.maraton.sljedeciKreceU}</b>. Budi spreman i ne propusti!
                    </div>
                    {this.state.maraton.trenutniIgracSpinova > 0 && this.state.maraton.trenutniIgracSpinova >= this.state.maraton.potrebnoSpinova && [<img key="img" className='kvalificirani' src='content/images/assets/img_kvalificirani.png'></img>]}
                </div>
            </div>





        if (aktivnaUtrka)
            return <div className={"line timer " + (firstHalf ? ' firstHalf' : ' secondHalf') + (trenutniPobjednik ? ' imamoPobjednika' : ' nemamoPobjednika')}>

                {firstHalf && <div key="first" >
                    <MaratonTimer key='i1'></MaratonTimer>
                    <div className="center-verticaly content" >
                        Još <b>{display} minuta</b> za kvalifikaciju.
                    {this.state.maraton.trenutniIgracSpinova == 0 && ' Zaigraj i sudjeluj u bonus maratonu!'}
                        {this.state.maraton.trenutniIgracSpinova > 0 && this.state.maraton.trenutniIgracSpinova < this.state.maraton.potrebnoSpinova && ' Potrebno je još samo malo da bi se kvalificirao.'}
                        {this.state.maraton.trenutniIgracSpinova > 0 && this.state.maraton.trenutniIgracSpinova >= this.state.maraton.potrebnoSpinova && [' Dok čekaš da počne treniraj igranjem naše ponude.']}
                    </div>
                    {this.state.maraton.trenutniIgracSpinova > 0 && this.state.maraton.trenutniIgracSpinova >= this.state.maraton.potrebnoSpinova && [<img key="img" className='kvalificirani' src='content/images/assets/img_kvalificirani.png'></img>]}
                </div>}

                {!firstHalf && !trenutniPobjednik && <div >
                    <MaratonProgress key='p1' progress={this.state.maraton.statusUtrke}></MaratonProgress>
                    <div className="center-verticaly content" key="second">
                        {this.props.user == null && [<b key='i1'>Traje bonus maraton.</b>, ' Prijavi se i provjeri trenutni status!']}
                        {this.props.user != null && this.state.maraton.trenutniIgracSpinova >= this.state.maraton.potrebnoSpinova && [<b key='i2'> Utrka je u tijeku te si ti mogući dobitnik.</b>, ' Zavrti dobitni spin i osvoji nagradu!']}
                        {this.props.user != null && this.state.maraton.trenutniIgracSpinova < this.state.maraton.potrebnoSpinova && <b>Utrka je u tijeku.</b>}
                        {this.props.user != null && this.state.maraton.trenutniIgracSpinova < this.state.maraton.potrebnoSpinova && this.state.maraton.postojiSljedecaUtrka && ' Pripremi se i ne propusti kvalifikacije za slijedeću!'}
                    </div>
                </div>}

                {!firstHalf && trenutniPobjednik && <div key="third">
                    <MaratonProgress key='p2' progress={-1} color="#a5cf84"></MaratonProgress>
                    <div className="center-verticaly content" >
                        <b>Utrka je završena!</b> Čestitke pobjedniku.

                    </div>
                </div>}

            </div>
    }


    renderLine2(firstHalf, aktivnaUtrka, sljedecaUtrka) {
        return <div className="line igraci" key="secondHalf">
            {!aktivnaUtrka && <div className="center-verticaly content" >
                Igraj i kvalificiraj se u prvoj polovici sata i zavrti <b>sretni spin</b> u drugoj polovici.
            </div>}

            {aktivnaUtrka && firstHalf && <div className="center-verticaly content" >
                <b> {this.state.maraton.kvalificiranihIgraca} igrača </b> kvalificirano je za sljedeći bonus.
            </div>}
            {aktivnaUtrka && !firstHalf && !this.state.maraton.trenutniPobjednik && <div className="center-verticaly content" >
                <b> {this.state.maraton.kvalificiranihIgraca} igrača </b> se natječe za nagradu od <b>{casino.utils.switchKnToEur(this.state.maraton.prethodniPobjednik.dobitak)} {casino.utils.switchCurrencyKnToEur()}!</b>
            </div>}
            {aktivnaUtrka && !firstHalf && this.state.maraton.trenutniPobjednik && <div className="center-verticaly content" >
                <b> {this.state.maraton.kvalificiranihIgraca} igrača </b> se natjecalo za nagradu od <b>{casino.utils.switchKnToEur(this.state.maraton.prethodniPobjednik.dobitak)} {casino.utils.switchCurrencyKnToEur()}!</b>
            </div>}
        </div>
    }

    renderLine3(firstHalf, aktivnaUtrka, sljedecaUtrka) {
        return <div className="line dobitnik" key="thirdHalf">

            {firstHalf && !this.state.maraton.prethodniPobjednik &&
                <div className="center-verticaly content">
                    Čekamo prvog pobjednika!
                </div>}

            {firstHalf && this.state.maraton.prethodniPobjednik &&
                <div className="center-verticaly content">
                    <b>{this.state.maraton.prethodniPobjednik.igrac}</b> je u prethodnoj utrci u igri {this.state.maraton.prethodniPobjednik.igraNaziv} osvojio/la <b>{casino.utils.switchKnToEur(this.state.maraton.prethodniPobjednik.dobitak)} {casino.utils.switchCurrencyKnToEur()}.</b>
                </div>}

            {!firstHalf && this.state.maraton.trenutniPobjednik &&
                <div className="center-verticaly content" >
                <b>{this.state.maraton.trenutniPobjednik.igrac}</b> je u ovoj utrci u igri {this.state.maraton.trenutniPobjednik.igraNaziv} osvojio/la <b>{casino.utils.switchKnToEur(this.state.maraton.prethodniPobjednik.dobitak)} {casino.utils.switchCurrencyKnToEur()}!</b>
                </div>}

            {!firstHalf && !this.state.maraton.trenutniPobjednik && this.state.maraton.prethodniPobjednik &&
                <div className="center-verticaly content" >
                <b>{this.state.maraton.prethodniPobjednik.igrac}</b> je u prethodnoj utrci u igri {this.state.maraton.prethodniPobjednik.igraNaziv} osvojio/la <b>{casino.utils.switchKnToEur(this.state.maraton.prethodniPobjednik.dobitak)} {casino.utils.switchCurrencyKnToEur()}.</b>
                </div>}

            {!firstHalf && !this.state.maraton.trenutniPobjednik && !this.state.maraton.prethodniPobjednik &&
                <div className="center-verticaly content" >
                    Čekamo prvog pobjednika!
                </div>}



        </div>
    }
};
